import { Button } from 'antd';
import { AiOutlineBars } from 'react-icons/ai';
import Biniyog from '../Icons/Logo_Biniyog.webp';

export const Head = ({ setIsMobileNavOpen, onBrandButtonClick }: any) => {
  return (
    <>
      <div className="brand" onClick={onBrandButtonClick}>
        <img
          src={Biniyog}
          style={{ height: '68px', width: '213px', position: 'static', overflow: 'visible' }}
          alt=""
          loading="eager"
          decoding="async"
        />
      </div>
      <Button type="text" onClick={() => setIsMobileNavOpen(false)}>
        <AiOutlineBars
          style={{
            height: '30px',
            width: '30px',
            color: 'black',
          }}
        />
      </Button>
    </>
  );
};
export default Head;
